import QuizImageViewer from '../quizImageViewer/QuizImageViewer';
import QuizPdfViewer from '../quizPdfViewer/QuizPdfViewer';
import { isQuizQuestionImageFile } from '../../assets/utils/quizQuestionFile';

export default function QuizQuestionFileViewer({ fileUrl, downloadUrl, fileExtension, ...rest }) {
    const isImage = fileExtension
        ? isQuizQuestionImageFile(fileExtension)
        : isQuizQuestionImageFile(fileUrl);

    if (isImage) {
        return <QuizImageViewer fileUrl={fileUrl} downloadUrl={downloadUrl} {...rest} />;
    }

    return <QuizPdfViewer fileUrl={fileUrl} downloadUrl={downloadUrl} {...rest} />;
}
